export enum MyPageRPricesSelectBase {
    CUSTOM = 'Anderer Preis',
}
